import React from 'react';
import { PERSONAL_LOAN_VERTICAL } from 'types/mrph.vertical.constants';
import {
  PL_LOW_SCORE,
  PERSONAL_LOAN_PREQUAL_HIGH_CC_DEBT,
  PL_HIGH_SCORE,
  PL_HIGH_SCORE_OFFER,
  PL_SEE_ALL_OFFERS,
  PL_PREQUAL_OFFER_MODULE,
  PL_LOW_SCORE_OFFER,
  PERSONAL_LOAN_PREQUAL_HIGH_CC_DEBT_OFFER,
  PL_PREQUAL_OFFER_MODULE_OFFER,
  PL_NAVIGATION_OFFERS,
} from 'types/morph.pagePosition.constants';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import LoadingMask from 'partial/OfferManager/LoadingMask';
import { MARKETPLACE_CARDS, MARKETPLACE_CARDS_EXP } from './OfferCardConfig';
import PersonalLoanHighScoreModuleView from 'partial/OfferManager/modules/PersonalLoanModuleRedesign/PersonalLoanHighScoreModuleView';
import PersonalLoanLowScoreModuleView from 'partial/OfferManager/modules/PersonalLoanModuleRedesign/PersonalLoanLowScoreModuleView';
import PersonalLoanPrequalHighCcDebtView from 'partial/OfferManager/modules/PersonalLoanModuleRedesign/PersonalLoanPrequalHighCcDebtView';
import PersonalLoanOfferView from 'partial/OfferManager/modules/PersonalLoanModuleRedesign/PersonalLoanOfferView';
import 'partial/OfferManager/modules/PersonalLoanModuleRedesign/OfferModule.scss';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import SeeAll from 'components/SeeAllButton/index';
import { redirectPersonalLoanOfferWithStaticModule } from 'actions/offers.actions';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';
import PersonalLoanPrequalHighCcDebtExpView from './PersonalLoanPrequalHighCcDebtExpView';
import { useFlag } from 'hook/flag.hook';
import PersonalLoanLowScoreModuleExpView from './PersonalLoanLowScoreModuleExpView';
import { useSelector } from 'react-redux';
import { PL_PREQUAL_RESULT_KEY, selectForKey } from 'actions/datacache.actions';

const providerMapping = new Map([
  ['PERSONAL_LOAN_LOW_SCORE', PL_LOW_SCORE],
  ['PERSONAL_LOAN_HIGH_SCORE', PL_HIGH_SCORE],
  ['PERSONAL_LOAN_HIGH_DEBT', PERSONAL_LOAN_PREQUAL_HIGH_CC_DEBT],
  ['PERSONAL_LOAN_OFFER', PL_PREQUAL_OFFER_MODULE],
]);

const providerOfferMapping = new Map([
  ['PERSONAL_LOAN_LOW_SCORE', PL_LOW_SCORE_OFFER],
  ['PERSONAL_LOAN_HIGH_SCORE', PL_HIGH_SCORE_OFFER],
  ['PERSONAL_LOAN_HIGH_DEBT', PERSONAL_LOAN_PREQUAL_HIGH_CC_DEBT_OFFER],
  ['PERSONAL_LOAN_OFFER', PL_PREQUAL_OFFER_MODULE_OFFER],
]);

const ShowModulePersonalLoan = props => {
  const {
    offerInfo,
    onClickPrequalLowScore,
    onClickPrequalHighDebt,
    onClickPrequalHighDebtExp,
    onLinkClickEvent,
    plUpsellHighCCFlag,
    plUpsellLowScoreFlag,
    plUpsellHighScoreFlag,
    plPrequalOfferFlag,
    plPrequalResult,
    toPersonalLoanPage,
  } = props;
  const offerSpecificProps = {
    ...props,
    offerInfo: providerOfferMapping.get(offerInfo) || offerInfo,
  };
  const totalDebt = props?.creditInfo?.debtAnalysis?.creditCardDebt?.totalDebt;

  if (offerInfo === 'PERSONAL_LOAN_LOW_SCORE') {
    const plUpsellLowScoreOn =
      plUpsellLowScoreFlag?.config?.enabled &&
      totalDebt < plUpsellLowScoreFlag?.config?.credit_card_debt;
    if (plUpsellLowScoreOn) {
      return (
        <PersonalLoanLowScoreModuleExpView
          {...offerSpecificProps}
          onClickPrequal={onClickPrequalLowScore}
        />
      );
    } else {
      return (
        <PersonalLoanLowScoreModuleView
          {...offerSpecificProps}
          onClickPrequal={onClickPrequalLowScore}
        />
      );
    }
  } else if (offerInfo === 'PERSONAL_LOAN_HIGH_SCORE') {
    const plUpsellHighScoreOn =
      plUpsellHighScoreFlag?.config?.enabled &&
      plUpsellHighScoreFlag?.config?.credit_card_debt > totalDebt;
    if (plUpsellHighScoreOn) {
      return (
        <PersonalLoanHighScoreModuleView
          marketPlaceCards={MARKETPLACE_CARDS_EXP}
          onLinkClickEvent={onLinkClickEvent}
          {...offerSpecificProps}
        />
      );
    } else {
      return (
        <PersonalLoanHighScoreModuleView
          marketPlaceCards={MARKETPLACE_CARDS}
          onLinkClickEvent={onLinkClickEvent}
          {...offerSpecificProps}
        />
      );
    }
  } else if (offerInfo === 'PERSONAL_LOAN_HIGH_DEBT') {
    const plUpsellHighScoreOn =
      plUpsellHighCCFlag?.config?.enabled &&
      plUpsellHighCCFlag?.config?.credit_card_debt <= totalDebt;
    if (plUpsellHighScoreOn) {
      return (
        <PersonalLoanPrequalHighCcDebtExpView
          creditInfo={props.creditInfo}
          onClickPrequal={onClickPrequalHighDebtExp}
          {...offerSpecificProps}
        />
      );
    } else {
      return (
        <PersonalLoanPrequalHighCcDebtView
          creditInfo={props.creditInfo}
          onClickPrequal={onClickPrequalHighDebt}
          {...offerSpecificProps}
        />
      );
    }
  } else if (offerInfo === 'PERSONAL_LOAN_OFFER') {
    const plOffers = props?.offers;
    return (
      <PersonalLoanOfferView
        creditInfo={props.creditInfo}
        plOffers={plOffers}
        plPrequalResult={plPrequalResult}
        onClickPrequal={onClickPrequalHighDebt}
        toPersonalLoanPage={toPersonalLoanPage}
        plPrequalOfferFlag={plPrequalOfferFlag}
        {...offerSpecificProps}
      />
    );
  }
};

export const PersonalLoanModuleController = props => {
  const { plPrequalResult } = useSelector(state => ({
    plPrequalResult: selectForKey(PL_PREQUAL_RESULT_KEY, state)?.[0]?.result,
  }));
  const offerInfo = props?.offerInfo;
  const { dispatch, config } = props;

  const plUpsellHighCCFlag = useFlag('pl_upsell_high_cc_web');
  const plUpsellLowScoreFlag = useFlag('pl_upsell_low_score_web');
  const plUpsellHighScoreFlag = useFlag('pl_upsell_high_score_web');
  const plPrequalOfferFlag = useFlag('pl_prequal_offer_web');

  //SeenModule tracking name to be discussed
  const onClickPrequalLowScore = () => {
    props.eventHandler(CLICK, {
      'Click Type': 'See If I’m Pre-Qualified',
      Vertical: PERSONAL_LOAN_VERTICAL,
      'Module Name': providerMapping?.get(offerInfo),
      'Nav Location': 'Personal Loan',
    });

    dispatch(
      redirectPersonalLoanOfferWithStaticModule(
        props.history,
        'PREQUAL_FUNNEL',
      ),
    );
  };

  const onClickPrequalHighDebt = () => {
    props.eventHandler(CLICK, {
      'Click Type': 'Check Pre-Qualification',
      'Module Position': props.modulePosition,
      Vertical: PERSONAL_LOAN_VERTICAL,
      'Module Name': providerMapping?.get(offerInfo),
      'Nav Location': 'Personal Loan',
    });
    dispatch(
      redirectPersonalLoanOfferWithStaticModule(
        props.history,
        'PREQUAL_FUNNEL',
      ),
    );
  };

  const onClickPrequalHighDebtExp = () => {
    props.eventHandler(CLICK, {
      'Click Type': 'Pre-Qualify Now',
      'Module Position': props.modulePosition,
      Vertical: PERSONAL_LOAN_VERTICAL,
      'Module Name': providerMapping?.get(offerInfo),
      'Nav Location': 'Personal Loan',
    });
    let loanAmount = props?.creditInfo?.debtAnalysis?.creditCardDebt?.totalDebt;
    loanAmount = Math.round(loanAmount / 100) * 100;
    if (loanAmount > 50000) {
      loanAmount = 50000;
    }
    dispatch(
      redirectPersonalLoanOfferWithStaticModule(
        props.history,
        'PREQUAL_FUNNEL',
        `loanAmount=${loanAmount}&loanFor=CC_REFI`,
      ),
    );
  };

  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition: providerMapping?.get(offerInfo),
    Vertical: PERSONAL_LOAN_VERTICAL,
    modulePosition: props.modulePosition,
    moduleName: providerMapping?.get(offerInfo),
  });
  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  const toPersonalLoanPage = () => {
    props.eventHandler(CLICK, {
      'Click Type': plPrequalOfferFlag?.config?.enabled
        ? PL_NAVIGATION_OFFERS
        : PL_SEE_ALL_OFFERS,
      'Module Name': providerMapping?.get(offerInfo),
      'Nav Location': 'Personal Loan',
      Vertical: PERSONAL_LOAN_VERTICAL,
    });
    props.history.push('/offers?vertical=PERSONAL_LOAN');
  };

  const onLinkClickEventToPersonalLoan = item => {
    props.eventHandler(CLICK, {
      'Click Type': item?.text,
      'Module Position': props.modulePosition,
      Vertical: PERSONAL_LOAN_VERTICAL,
      'Module Name': providerMapping?.get(offerInfo),
      'Nav Location': 'Personal Loan',
    });
    dispatch(
      redirectPersonalLoanOfferWithStaticModule(
        props?.history,
        'PREQUAL_FUNNEL',
        item?.queryParameters,
      ),
    );
  };

  const loading = props.globalLoadingFlag;
  if (loading) {
    return <LoadingMask />;
  } else {
    return (
      <FlexContainer className={'flex-column'}>
        {seenModuleTracking}
        <FlexContainer
          className={'justify-between align-center align-baseline margB14'}
        >
          {!plPrequalOfferFlag?.config?.enabled && (
            <>
              <Label
                type="H4"
                typeHeader={'h2'}
                className={'margB0 m-text-12 system_neutral_n500_text'}
              >
                Personal loans for your profile
              </Label>
              <SeeAll
                onClick={toPersonalLoanPage}
                className={
                  'm-margT6 text-12 m-text-12 align-baseline secondary_text_light noWrapText'
                }
              />
            </>
          )}
          {plPrequalOfferFlag?.config?.enabled && (
            <Label
              className={
                'margB0 bold text-24 m-text-20 system_neutral_n500_text'
              }
            >
              Personal Loan offers for you
            </Label>
          )}
        </FlexContainer>
        {config?.showDisclaimerInOffers && (
          <Disclaimer showPartnerText className="margB8" />
        )}
        <ShowModulePersonalLoan
          moduleName={providerMapping?.get(offerInfo)}
          offerInfo={offerInfo}
          plPrequalResult={plPrequalResult}
          onClickPrequalLowScore={onClickPrequalLowScore}
          onClickPrequalHighDebt={onClickPrequalHighDebt}
          onClickPrequalHighDebtExp={onClickPrequalHighDebtExp}
          onLinkClickEvent={onLinkClickEventToPersonalLoan}
          toPersonalLoanPage={toPersonalLoanPage}
          plUpsellHighCCFlag={plUpsellHighCCFlag}
          plUpsellLowScoreFlag={plUpsellLowScoreFlag}
          plUpsellHighScoreFlag={plUpsellHighScoreFlag}
          plPrequalOfferFlag={plPrequalOfferFlag}
          {...props}
        />
      </FlexContainer>
    );
  }
};
